import { DatePipe } from '@angular/common';
import { Component, OnInit,Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EditPowerUserComponent } from '../../../Component/user-management/edit-power-user/edit-power-user.component';
// import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { PowerUserRoleFormData, SubjectList } from '../../../Models/user-profiles.model';
import { UserManagementService } from '../../../Services/user-management/user-management.service';
import { ToastrService } from 'ngx-toastr';
import {SessionService} from '../../../Services/session.service';
import { IGetCodes } from 'src/app/interfaces/codes';

@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-edit-assign-role-to-power-user',
  templateUrl: './edit-assign-role-to-power-user.component.html',
  styleUrls: ['./edit-assign-role-to-power-user.component.scss']
})
export class EditAssignRoleToPowerUserComponent implements OnInit {
 previewurl:string
 PowerUserRoleId:number
  selectRole: any[];
  roleStatus: any[];
  values: any[]=[];
  subjectNames: string = "";
  subjectListArray: any[] = [];
  userRole: any;
  deletealertpopup:boolean;
  //modifyUserRoles: any;
  modifyUserRole: PowerUserRoleFormData;
  DataUpdateFlag:boolean=false;
  currentRole: string;
  subjectType: IGetCodes[];
  selectedRole: any;
  disableSelectForUserRole: boolean;
  duplicateflag:boolean
  SecondarySubjectlist:any[]=[];
  SecondarySubjectlist1:any[]=[];
  selectedPowerUserRole: any;
  subjectlist:any;
  Disable:boolean;
  //PrimarySubjectlist:any;
  todayDate:Date = new Date();
  PrimarySubjectlist: any[] = []
  PrimarySubjectlist1:any[]=[]
  ChangePowerUserRoleStatus:boolean=false;
  PowerUserRoleInd:string;
  assignRoleToPowerUserForm = new FormGroup({
    powerUserId: new FormControl(''),
    status: new FormControl(''),
    selectRole: new FormControl('', Validators.required),
    startDate: new FormControl('', Validators.required),
    primarySubject: new FormControl('', Validators.required),
    powerUser: new FormControl(''),
    name: new FormControl(''),
    endDate: new FormControl(''),
    additionalSubject: new FormControl(''),
    roleStatus: new FormControl(''),
    comments: new FormControl('')

  })
  PowerUserID: any;
  subjects: any[] =[];
  firstTimeChanged: boolean =false;

  constructor(
    public session:SessionService,
    public toastr: ToastrService,
    private router: Router,
    public userService: UserManagementService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private readonly toaster: ToastrService,
  ) {

    this.todayDate=new Date(this.todayDate.setDate(this.todayDate.getDate() - 1));
    // this.PowerUserRoleInd=this.userService.Power_User_Role_Ind;
    if(this.PowerUserRoleInd=='Y'){
      this.Disable=false;
    }
    if(this.PowerUserRoleInd=='N'){
      this.Disable=true;
    }

   }

  ngOnInit(): void {
    this.getExperienceType();
    this.getSubjectType();
    // this.getStatusType();
    this.route.params.subscribe((e)=>{
      this.PowerUserID =e?.id
      this.PowerUserRoleId = +e?.pid
      const payload={
        "PowerUserRoleID": this.PowerUserRoleId,
      "SubjectID": null,
      "PowerUserID": null,
      "ScreenName": null,
    }

      this.userService.getPowerUserRoleById(payload).subscribe(
        (res:any) => {

          this.getPoweruserRoleByIdResponse(res?.PowerUserRole) },
        error => { console.log(error) }
      )
    })

    if(this.PowerUserRoleInd=='Y'){
      this.Disable=false;
    }
    if(this.PowerUserRoleInd=='N'){
      this.Disable=true;
    }
    // this.router.events
    //         .pipe(filter((e: any) => e instanceof RoutesRecognized),
    //             pairwise()
    //         ).subscribe((e: any) => {
    //             console.log(e[0].urlAfterRedirects,'previewurl'); // previous url
    //             this.previewurl=e[0].urlAfterRedirects;
    //         });
  }

  powerUserRoleSubjects:any[]=[];
  getPoweruserRoleByIdResponse(data : any[]=[]) {
    this.selectedPowerUserRole = data[0];
    // Safe normalize to array
this.powerUserRoleSubjects = Array.isArray(data)
  ? JSON.parse(JSON.stringify(data))  // Deep clone array
  : (data != null ? [JSON.parse(JSON.stringify(data))] : []);


    this.subjects = data;
    console.log(this.selectedPowerUserRole,'selectedPowerUserRole');
    this.assignRoleToPowerUserForm.controls['powerUserId'].setValue(this.selectedPowerUserRole.Power_User_ID);
    //this.assignRoleToPowerUserForm.controls['powerUserId'].disable();
    this.assignRoleToPowerUserForm.controls['status'].setValue(this.selectedPowerUserRole.Power_User_Role_Status_Type_Code);
    //this.assignRoleToPowerUserForm.controls['status'].disable();
    this.assignRoleToPowerUserForm.controls['name'].setValue(this.selectedPowerUserRole.Power_User_Name);
    //this.assignRoleToPowerUserForm.controls['name'].disable();
    this.assignRoleToPowerUserForm.controls['selectRole'].setValue(this.selectedPowerUserRole.Power_User_Role_Type_Code);
    //this.assignRoleToPowerUserForm.controls['selectRole'].disable();
    this.currentRole = this.selectedPowerUserRole.Power_User_Role_Type_Code;
    this.assignRoleToPowerUserForm.controls['startDate'].setValue(new Date(new Date(this.selectedPowerUserRole.Start_Date).getTime()));
    this.assignRoleToPowerUserForm.controls['endDate'].setValue(this.selectedPowerUserRole.End_Date);
    this.assignRoleToPowerUserForm.controls['comments'].setValue(this.selectedPowerUserRole.Comment_Text);
    this.assignRoleToPowerUserForm.controls['primarySubject'].setValue(data.find((e:any)=> e.Primary_Subject_Ind === 'Y' )?.Subject_Id);
    this.PowerUserRoleInd = this.selectedPowerUserRole.Role_Updatable_Ind
    console.log(data.find((e:any)=> e.Primary_Subject_Ind === 'Y' )?.Subject_Id,"selected");

    this.values =  data.filter((e)=> e.Primary_Subject_Ind !== 'Y').map((e)=> ({Code:e?.Subject_Id}))
    // this.subjectlist=this.selectedPowerUserRole.SubjectList;
    //this.subjectListArray=this.subjectlist;
    console.log(this.assignRoleToPowerUserForm,'assignRoleToPowerUserForm')

    // this.getsubject(this.subjectlist);
  }


  // OnClickCancelButton() {

  //   this.router.navigate(['User/Poweruserlist']);
  // }

  OnClickChangeStatus() {
    this.router.navigate(['/changeUserRoleStatus']);
    //this.dialog.closeAll();
  }

  Closebutton(){
    if(this.userService.Screenurl=='editPowerUser'){
    this.router.navigate(['/editPowerUser']);
    }
    else if(this.userService.Screenurl=='User/Poweruserlist'){
      this.router.navigate(['User/Poweruserlist']);
    }
    else{

    }
  }

  onSelectRole(event: any) {
    this.selectedRole = event.target.value;
  }
  subjectlength:number
  getsubject(element:any){

    for(let i=0;i<element.length;i++){
      if(element[i].PrimarySubjectInd=='Y'){
        this.PrimarySubjectlist.push({
          Code: element[i].SubjectId,
          PrimarySubjectInd: element[i].PrimarySubjectInd,
          PowerUserRoleId:element[i].PowerUserRoleId,
          PowerUserSubjectId:element[i].PowerUserSubjectId
        })
        this.PrimarySubjectlist1.push({
          subjectId: element[i].SubjectId,
          primarySubjectInd: element[i].PrimarySubjectInd,
          powerUserRoleId:element[i].PowerUserRoleId,
          powerUserSubjectId:element[i].PowerUserSubjectId
        })
      }
      else if(element[i].PrimarySubjectInd=='N'&&element[i].PowerUserSubjectId!=null){
        this.SecondarySubjectlist.push({
          // SubjectId: element.SubjectId,
          // PrimarySubjectInd: element.PrimarySubjectInd,
          // PowerUserRoleId:element.PowerUserRoleId,
          // PowerUserSubjectId:element.PowerUserSubjectId
          Code: element[i].SubjectId,
          PowerUserSubjectId:element[i].PowerUserSubjectId
          //Name: this.subjectType[i].Name
        })
        this.SecondarySubjectlist1.push({
          subjectId: element[i].SubjectId,
          primarySubjectInd: element[i].PrimarySubjectInd,
          powerUserRoleId:element[i].PowerUserRoleId,
          powerUserSubjectId:element[i].PowerUserSubjectId
        })
      }
    }

    // data.forEach((element: { SubjectId:any;PrimarySubjectInd:any,PowerUserRoleId:any,PowerUserSubjectId:any})=>
    // {
    //     if(element.PrimarySubjectInd=='Y'){
    //       this.PrimarySubjectlist.push({
    //         Code: element.SubjectId,
    //         PrimarySubjectInd: element.PrimarySubjectInd,
    //         PowerUserRoleId:element.PowerUserRoleId,
    //         PowerUserSubjectId:element.PowerUserSubjectId
    //       })
    //     }
    //     else if(element.PrimarySubjectInd=='N'&&element.PowerUserSubjectId!=null){
    //       this.SecondarySubjectlist.push({

    //         Code: element.SubjectId,
    //         Name: this.subjectType[].Name
    //       })
    //     }

    // })

    this.assignRoleToPowerUserForm.controls['primarySubject'].setValue(this.PrimarySubjectlist[0].Code);
    //this.subjectListArray=this.PrimarySubjectlist1;
    this.subjectListArray=this.PrimarySubjectlist1. concat(this.SecondarySubjectlist1);
    this.subjectlength=this.subjectListArray.length;
    this.values=this.SecondarySubjectlist;
    console.log(this.values,'values');

  }


  getSubjectType() {
    this.userService.getSubject('SUBJECT').subscribe(
      res => {
        // console.log(res)
        this.getSubjectTypeResponse(res)
      },
      error => {
        console.log(error)
      }
    )
  }

  OnClickSaveButton() {

    this.ModifyOnClickSubmitRole(this.assignRoleToPowerUserForm.value)
  }

  ModifyOnClickSubmitRole(data: any) {
    let tempUserRole: PowerUserRoleFormData;
    tempUserRole = {} as PowerUserRoleFormData;

    //this code can be cleaned up using the same variable selectedUserRole used before
    tempUserRole = {
      powerUserRoleId: this.userService.powerUserRoleID,
      powerUserId: this.userService.powerUserId,
      powerUserRoleType: this.selectedPowerUserRole.PowerUserRoleType,
      startDate:this.datepipe.transform(data.startDate,'MM/dd/yyyy'),
      endDate:this.datepipe.transform(data.endDate,'MM/dd/yyyy'),
      comment:data.comments,
      statusType:"New",
      loggedInUser:this.session.getUser(),
      SubjectList:this.subjectListArray
    }

    this.modifyUserRole = tempUserRole;
    this.values.forEach(val => {
      const exists = this.subjects.some(sub => sub.Subject_Id === val.Code);
      if (!exists) {
        const matchingSubject = this.subjects.find(() => true); // copy structure from first subject
        if (matchingSubject) {
          const newSubject = {
            ...matchingSubject,
            Subject_Id: +val.Code,
            Subject_Name: "", // optionally fetch from some other list
            Primary_Subject_Ind: "N", // assuming new ones are secondary
            Power_User_Subject_Id: null  // since it's new
          };
          this.subjects.push(newSubject);
        }
      }
    });


    const payload = {
      "powerUserRoleId": this.subjects[0]?.Power_User_Role_Id,
      "powerUserId": this.PowerUserID,
      "powerUserRoleType": this.assignRoleToPowerUserForm.controls['selectRole'].value,
      "startDate": this.assignRoleToPowerUserForm.controls['startDate'].value,
      "endDate": this.assignRoleToPowerUserForm.controls['endDate'].value,
      "comment": this.assignRoleToPowerUserForm.controls['comments'].value,
      "statusType": this.assignRoleToPowerUserForm.controls['status'].value,
      "SubjectList": this.subjects.map((e)=>{
        return{
          powerUserSubjectId: e.Power_User_Subject_Id,
          // powerUserRoleId: e.Power_User_Role_Id,
          subjectId: +e.Subject_Id,
          primarySubjectInd: e.Primary_Subject_Ind,
      }
      })
  }

    this.userService.modifyUserRole(payload).subscribe(

      res => {
        console.log(res);
        this.toastr.success('Success!', 'UserRole Is Updated!');
        this.router.navigate(['User/Poweruserlist']);
        console.log(res)
      },
      error => {
       this.toastr.error('ERROR!', error.error.Message);
      }
    )
  }

  primaryselected:boolean=false;
  secondaryselected:boolean=false;
  onSelectPrimarySubject(event: any) {

    const subjectId = event.target.value;
    // Step 1: Check if subject already exists in additional subjects
    if (this.values.some((e) => e.Code == subjectId)) {
      this.toaster.error('This Subject Already Exists in additional subjects');

      const existingPrimary = this.subjects.find((s: any) => s.Primary_Subject_Ind === 'Y')?.Subject_Id;
      this.assignRoleToPowerUserForm.controls['primarySubject'].setValue(existingPrimary);
      return;
    }

    // Step 2: Update only the Subject_Id of the primary subject
    const primarySubject = this.subjects.find((s: any) => s.Primary_Subject_Ind === 'Y');
    if (primarySubject) {
      primarySubject.Subject_Id = subjectId;
      primarySubject.powerUserSubjectId =null
    }
//     var tempPrimarySubjectList: SubjectList;
//     var eventArr = event.target.value.split(" ");
//     this.primaryselected=true;
//     tempPrimarySubjectList = ({
//       powerUserSubjectId: this.PrimarySubjectlist[0].PowerUserSubjectId,
//       powerUserRoleId: this.userService.powerUserRoleID,
//       subjectId: eventArr[0],
//       primarySubjectInd: "Y",

//     })

//     if(this.subjectListArray.length>0){
//       this.subjectListArray.forEach((value) => {
//         // if(value.primarySubjectInd=='Y'){
//         //   this.subjectListArray.splice(index, 1);
//         // }
//         if(value.subjectId==eventArr[0]){
//           this.duplicateflag=true;
//         }

//     });
//     if(!this.duplicateflag){
//       for(var i=0;i<this.subjectListArray.length;i++){
//         if(this.subjectListArray[i].subjectId==this.currentdropdown){
//           this.subjectListArray.splice(i,1);
//         }
//        }
//       this.subjectNames = this.subjectNames + eventArr[1];
//       this.subjectListArray.push(tempPrimarySubjectList);
//     }
//     else{
//       for(var i=0;i<this.subjectListArray.length;i++){
//         if(this.subjectListArray[i].subjectId==this.currentdropdown){
//           this.subjectListArray.splice(i,1);
//         }
//        }
//        this.duplicateflag=false;
//       this.subjectalertpopup('Y');
//     }
//   }
//   else{
//     this.subjectNames = this.subjectNames + eventArr[1];
//           this.subjectListArray.push(tempPrimarySubjectList);
//  }

//  this.Editformvalidation();
    // this.subjectNames = this.subjectNames + eventArr[1]
    // this.subjectListArray.push(tempPrimarySubjectList)
    // console.log(this.subjectNames)
    // console.log(tempPrimarySubjectList)
  }



  onSelectAdditionalSubject(event: any,value:any) {
    var tempAdditionalSubjectList: SubjectList;
    var eventArr = event.target.value.split(" ");
    this.secondaryselected=true;
    if(this.subjectListArray.length>0){
      this.subjectListArray.forEach((value, index) => {
        if(value.subjectId==eventArr[0]){
          this.duplicateflag=true;

        }
    });

    if(!this.duplicateflag){
      if(this.values[value].PowerUserSubjectId>0){
        tempAdditionalSubjectList = ({
          powerUserSubjectId: this.values[value].PowerUserSubjectId,
          powerUserRoleId: this.userService.powerUserRoleID,
          subjectId: eventArr[0],
          primarySubjectInd: "N",
        })
      }
      else{
        tempAdditionalSubjectList = ({
          powerUserSubjectId: 0,
          powerUserRoleId: this.userService.powerUserRoleID,
          subjectId: eventArr[0],
          primarySubjectInd: "N",
        })
      }
      for(var i=0;i<this.subjectListArray.length;i++){
        if(this.subjectListArray[i].subjectId==this.currentdropdown){
          this.subjectListArray.splice(i,1);
        }
       }
      this.subjectNames = this.subjectNames + eventArr[1];
      this.subjectListArray.push(tempAdditionalSubjectList);
    }
    else{
      for(var i=0;i<this.subjectListArray.length;i++){
        if(this.subjectListArray[i].subjectId==this.currentdropdown){
          this.subjectListArray.splice(i,1);
        }
    }
      this.duplicateflag=false;
      this.subjectalertpopup(value);
    }
  }
  else{

   if(this.values[value].PowerUserSubjectId>0){
        tempAdditionalSubjectList = ({
          powerUserSubjectId: this.values[value].PowerUserSubjectId,
          powerUserRoleId: this.userService.powerUserRoleID,
          subjectId: eventArr[0],
          primarySubjectInd: "N",
        })
      }
      else{
        tempAdditionalSubjectList = ({
          powerUserSubjectId: 0,
          powerUserRoleId: this.userService.powerUserRoleID,
          subjectId: eventArr[0],
          primarySubjectInd: "N",
        })
      }
    // this.values=this.SecondarySubjectlist;
    this.subjectNames = this.subjectNames + eventArr[1]
    this.subjectListArray.push(tempAdditionalSubjectList);
  }
  this.Editformvalidation();
  }

  getSubjectTypeResponse(data: any) {


    this.subjectType = data;
    console.log(this.subjectType,'subjectType');
  }

  //SREE: all these codes can be moved to a common service layer so we can call easily.
  getExperienceType() {
    this.userService.getCodes('POWER_USER_ROLE_TYPE').subscribe(
      res => {
        this.getRoleTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }

  getRoleTypeResponse(data: any) {
    var tempRoleType: any[] = []
    data.forEach((element: { Code: any; Name: any; }) => {
      tempRoleType.push({
        Code: element.Code,
        Name: element.Name
      })

    });
    this.selectRole = tempRoleType;
    // console.log(this.selectRole)
  }

  getStatusType() {
    this.userService.getCodes('POWER_USER_ROLE_STATUS_TYPE').subscribe(
      res => {
        this.getStatusTypeResponse(res)

      },
      error => {
        console.log(error)
      }

    )
  }

  getStatusTypeResponse(data: any) {
    var tempRoleStatusType: any[] = []

    data.forEach((element: { Code: any; Name: any; }) => {
      tempRoleStatusType.push({
        Code: element.Code,
        Name: element.Name
      })

    });

    this.roleStatus = tempRoleStatusType;
  }

  removeindex:number
  removevalue(i: number,subject:any) {

    const indexToRemove = this.subjects.findIndex(s => s.Subject_Id === subject.Code);
    if (indexToRemove !== -1) {
      this.subjects.splice(indexToRemove, 1);
    }

    this.removeindex=i;
    if(this.values[i].PowerUserSubjectId>0){
      for(var j=0;j<this.subjectListArray.length;j++){
        if(this.subjectListArray[j].subjectId==this.values[i].Code){
          this.subjectListArray.splice(j,1);
        }
      }
      this.Removealertpopup();
    }
    else{
      for(var j=0;j<this.subjectListArray.length;j++){
        if(this.subjectListArray[j].subjectId==this.values[i].Code){
          this.subjectListArray.splice(j,1);
        }
      }
      this.values.splice(i, 1);
    }
    this.Editformvalidation();

  }

 Removealertpopup()
 {
  this.deletealertpopup=!this.deletealertpopup;
 }
 Remove(){
    this.DeleteSubject(this.values[this.removeindex]);
    this.values.splice(this.removeindex, 1);
 }

DeleteSubject(data:any){
    this.userService.DeletePowerUserRoleSubject({'LoggedInUser':'Vel_S_Pil_1','Power_User_Subject_Id':data.PowerUserSubjectId}).subscribe(

      res => {
        console.log(res);
        this.toastr.success('Success!', 'Subject Removed');
       // this.router.navigate(['User/Poweruserlist']);
        this.Removealertpopup();
        console.log(res)
      },
      error => {
       this.toastr.error('ERROR!', 'Subject Not Removed');
      }
    )

  }

  addvalue() {
    this.values.push({ Code: "",PowerUserSubjectId:0});
    console.log(this.values)
  }
  OnClickCStatusButton(){
    this.ChangePowerUserRoleStatus=!this.ChangePowerUserRoleStatus;
  }

  Closepopup(data:any){
    if(this.ChangePowerUserRoleStatus){
      this.OnClickCStatusButton();
    }

  }

  currentdropdown:any;
  getvalue(event: any){
    this.currentdropdown = event.target.value;
    console.log(this.currentdropdown,'currentdropdown')
  }

  clearform(){

    if(this.Indexvalue!='Y'){
      if(this.values[this.Indexvalue].PowerUserSubjectId<=0)
      {
        this.values[this.Indexvalue].PowerUserSubjectId=0;
      }
     this.values[this.Indexvalue].Code="";

     this.subjectalertpopup(1);
    }
    else{
     this.assignRoleToPowerUserForm.controls['primarySubject'].setValue("");
     this.subjectalertpopup(1);
    }

   }

   subjectalertflag:boolean
   Indexvalue:any
  subjectalertpopup(index:any){
    this.Indexvalue=index;
    this.subjectalertflag=!this.subjectalertflag;
  }


  Cancelbutton(){
    this.Editformvalidation();

    if(this.DataUpdateFlag){
      this.AlertCancelpopup();
    }
    else{
     this.DiscardChanges();
    }

     //this.router.navigate(['User/Poweruserlist']);


   }
   cancelalertflag:boolean
   AlertCancelpopup(){
    this.cancelalertflag=!this.cancelalertflag;
   }

   DiscardChanges(){
     this.AlertCancelpopup();
      this.router.navigate(['User/Poweruserlist']);
   }

   error: any = { isError: false, errorMessage: '' };

   compareEndDates(): void {
     this.Editformvalidation();

     const startDate = new Date(this.assignRoleToPowerUserForm.controls['startDate'].value);
     const endDateValue = this.assignRoleToPowerUserForm.controls['endDate'].value;

     // Early return: if end date is null
     if (!endDateValue) {
       this.error = { isError: false, errorMessage: '' };
       return;
     }

     const endDate = new Date(endDateValue);

     // Normalize both dates (ignore time)
     startDate.setHours(0, 0, 0, 0);
     endDate.setHours(0, 0, 0, 0);

     const formattedEndDate = this.datepipe.transform(endDate, 'dd/MM/yyyy');
     const formattedOriginalEndDate = this.datepipe.transform(this.selectedPowerUserRole.EndDate, 'dd/MM/yyyy');

     // If the selected end date matches the original, no error
     if (formattedEndDate === formattedOriginalEndDate) {
       this.error = { isError: false, errorMessage: '' };
       return;
     }

     // Validation: End date can't be before start date (after edit)
     if (endDate < startDate) {
       this.error = { isError: true, errorMessage: 'End Date can’t be before Start Date' };
     } else {
       this.error = { isError: false, errorMessage: '' };
     }
   }


    error1:any={isError:false,errorMessage:''};

    onStartDateChanged(event: any): void {
      // if (this.PowerUserID && !this.firstTimeChanged) {
      //   this.firstTimeChanged = true;
      //   return; // skip first-time validation
      // }
      this.compareStartDates();
    }

    compareStartDates(): void {
      this.Editformvalidation();

      const startDate = new Date(this.assignRoleToPowerUserForm.controls['startDate'].value);
      const today = new Date();

      // Normalize both dates to ignore time (compare only by date)
      startDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);

      const formattedStartDate = this.datepipe.transform(startDate, 'dd/MM/yyyy');
      const formattedOriginalDate = this.datepipe.transform(this.selectedPowerUserRole.StartDate, 'dd/MM/yyyy');

      if (formattedStartDate === formattedOriginalDate) {
        this.error1 = { isError: false, errorMessage: '' };
      } else if (startDate < today) {
        this.error1 = { isError: true, errorMessage: 'Start Date can’t be before current date' };
      } else {
        this.error1 = { isError: false, errorMessage: '' };
      }

      this.compareEndDates();
    }



   Editformvalidation()
   {
     if(this.assignRoleToPowerUserForm.valid){
     var powerUserId = this.assignRoleToPowerUserForm.controls['powerUserId'].value;
     var status = this.assignRoleToPowerUserForm.controls['status'].value;
     var selectRole = this.assignRoleToPowerUserForm.controls['selectRole'].value;
     var startDate = this.assignRoleToPowerUserForm.controls['startDate'].value;
     var endDate = this.assignRoleToPowerUserForm.controls['endDate'].value;
     var primarySubject = this.assignRoleToPowerUserForm.controls['primarySubject'].value;
     var powerUser = this.assignRoleToPowerUserForm.controls['powerUser'].value;
     var name = this.assignRoleToPowerUserForm.controls['name'].value;
     var roleStatus = this.assignRoleToPowerUserForm.controls['roleStatus'].value;
     var comments = this.assignRoleToPowerUserForm.controls['comments'].value;
     var subjectlist=this.PrimarySubjectlist1. concat(this.SecondarySubjectlist1);
console.log(this.datepipe.transform(startDate, 'dd/MM/yyyy'),this.datepipe.transform(this.selectedPowerUserRole.Start_Date, 'dd/MM/yyyy'));

     if(this.datepipe.transform(startDate, 'dd/MM/yyyy')!=this.datepipe.transform(this.selectedPowerUserRole.Start_Date, 'dd/MM/yyyy'))
     {
     this.DataUpdateFlag=true;
     }
     else if(this.datepipe.transform(endDate, 'dd/MM/yyyy')!=this.datepipe.transform(this.selectedPowerUserRole.EndDate, 'dd/MM/yyyy'))
     {
     this.DataUpdateFlag=true;
     }
     else if(comments!=this.selectedPowerUserRole.Comment_Text)
     {
     this.DataUpdateFlag=true;
     }
     else if(primarySubject!=this.powerUserRoleSubjects.find((e:any)=> e.Primary_Subject_Ind === 'Y' )?.Subject_Id)
     {
      this.DataUpdateFlag=true;
     }
    //  else if(this.subjectlength!=this.subjectListArray.length){
    //   this.DataUpdateFlag=true;
    //  }
     else if(this.primaryselected){
      this.DataUpdateFlag=true;
     }
     else if(this.secondaryselected){
      this.DataUpdateFlag=true;
     }

    //  else if(this.removeindex!=null&&this.removeindex!=undefined){
    //   this.DataUpdateFlag=true;
    //  }
     else{
     this.DataUpdateFlag=false;

    }

  }
 }
}



